var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pbrTopicInfographicChart",staticClass:"pbr-topic-chart-container",staticStyle:{"height":"190px"}},[_vm._v(" 信息图谱 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }